import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { FXFormFieldConfig } from 'types/operations.ts';

const SKIP_LENGTH_RULES = new Set(['beneficiary.bank.bic']);

export const useValidationRules = (fieldKey: string, fieldConfig: FXFormFieldConfig) => {
	const { t } = useTranslation();

	return useMemo(() => {
		const rules: Record<string, unknown> = {
			required: fieldConfig.required ? t('payments.newPayment.fieldIsRequired') : false,
		};

		if (!SKIP_LENGTH_RULES.has(fieldKey) && Array.isArray(fieldConfig.length)) {
			const [min, max] = fieldConfig.length;
			if (min !== undefined) {
				rules.minLength = {
					value: min,
					message: `${t('payments.newPayment.additionalData.fx.minLength')}${min}`,
				};
			}
			if (max !== undefined) {
				rules.maxLength = {
					value: max,
					message: `${t('payments.newPayment.additionalData.fx.maxLength')}${max}`,
				};
			}
		}

		return rules;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fieldKey, fieldConfig]);
};
